import { useQuery } from 'react-query';

import { api } from '@services';
import { PublicQuestion } from '@common/types/api/public-questions/response';

export const usePublicQuestionsQuery = (roomId?: number) =>
  useQuery(
    ['public-questions', roomId],
    async () => {
      const { data } = await api.get<{ data: PublicQuestion[] }>(
        `/rooms/${roomId}/public-questions`,
      );
      return data.data;
    },
    {
      enabled: !!roomId,
      refetchInterval: 10000, // Atualizar a cada 10s
      staleTime: 5000,
    },
  );
